import { STORAGE_KEY } from '@/constants';
import { request } from '@umijs/max';
import { message } from 'antd';

interface ResponseStructure<T = any> {
  code: number;
  message: string;
  data: T;
}

interface RequestOptions {
  showError?: boolean; // 是否显示错误提示
  [key: string]: any; // 其他请求选项
}

// 处理 GET 请求的数组参数
function processArrayParams(params: Record<string, any>) {
  const processedParams: Record<string, any> = {};

  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      if (value.length > 0) {
        // 跟后端约定好如果是数组类型，使用逗号分隔
        processedParams[key] = value.join(',');
      }
    } else {
      processedParams[key] = value;
    }
  }

  return processedParams;
}

// 请求包装器
export async function requestWrapper<T>(
  url: string,
  options: RequestOptions = { showError: true, baseUrl: API_URL },
): Promise<T> {
  // 处理 GET 请求的数组参数
  if (options.method?.toUpperCase() === 'GET' && options.params) {
    options.params = processArrayParams(options.params);
  }

  const { showError = true, baseUrl = API_URL, ...restOptions } = options;

  // 拼接完整的 URL
  const fullUrl = url.startsWith('http') ? url : `${baseUrl || ''}${url}`;

  try {
    const res = await request<ResponseStructure<T>>(fullUrl, {
      ...restOptions,
      // 设置默认的请求头
      headers: {
        'X-Token': window.localStorage.getItem(STORAGE_KEY.loginToken) || '',
        credentials: 'include', // 确保每个请求都带上 credentials
      },
    });

    if (res.code === 0) {
      return res.data;
    }
    // 请求成功但业务失败
    if (showError) {
      message.error(res.message || '请求失败');
    }
    return Promise.reject(res);
  } catch (error: any) {
    // 请求失败
    if (showError) {
      const errMsg = error.response?.data?.message;
      switch (error.response.status) {
        case 401:
          message.error(errMsg || '请先登录');
          setTimeout(() => {
            window.location.href = '/login';
          }, 2000);
          break;
        default:
          message.error(errMsg || '网络错误');
      }
    }
    return Promise.reject(error);
  }
}
